var _excluded = ["className"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import { styled } from '@mui/material/styles';
import Tab, { tabClasses } from '@mui/material/Tab';
var StyledTab = styled(Tab)(function (_ref) {
  var _objectSpread2;
  var _ref$theme = _ref.theme,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing,
    typography = _ref$theme.typography;
  var height = spacing(6);
  return _objectSpread(_objectSpread({
    border: '2px solid transparent',
    color: palette.text.primary,
    minHeight: height,
    minWidth: spacing(6),
    padding: [[0, spacing(2)]]
  }, typography.button), {}, (_objectSpread2 = {
    '&[class*="focusVisible"]': {
      borderColor: palette.primary.main
    }
  }, _defineProperty(_objectSpread2, "& > .".concat(tabClasses.iconWrapper), {
    fontSize: spacing(2),
    marginRight: spacing(0.5)
  }), _defineProperty(_objectSpread2, "&.".concat(tabClasses.labelIcon), {
    minHeight: height
  }), _objectSpread2));
});

/**
 * This component can be used with `SovosTabs` to render a tab bar.
 * However, `SovosTabContents` and `SovosTabGroup` will generate tabs and
 * handle tab switching and should be used in most situations.
 */
var SovosTab = function SovosTab(_ref2) {
  var className = _ref2.className,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledTab, _extends({
    className: clsx('sovosTab', className),
    iconPosition: "start",
    disableRipple: true
  }, rest));
};
SovosTab.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosTab.baseComponent = {
  name: 'Tab',
  link: 'tab/'
};
export default SovosTab;